import React from "react";
import { Translate } from "components/common/Translate/Translate";
import { Section8UseCaseScaffold } from "components/features/CompressorCommon/Section8UseCaseScaffold";
import { ImageConverterPageTemplateInterface } from "@/templates/ImageConverterPageTemplateInterface";

const ImageConverterSection8Highlight = ({ template }: { template: ImageConverterPageTemplateInterface }) => {
    if (!template.section8) return <></>;
    return (
        <Section8UseCaseScaffold
            title={<Translate keyName={template.section8.title} />}
            useCases={template.section8.items}
        />
    );
};

export default ImageConverterSection8Highlight;
